import React, { Component } from "react";
import { connect } from "react-redux";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../store/actions/index";
import { getDateFromTime, getShipment } from "../../store/utility";
import Spinner from "../Spinner/Spinner";
import OrderRow from "../UI/OrderRow/OrderRow";

class OngoingOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: false,
    };
    this.handleCancelOrder = this.handleCancelOrder.bind(this);
  }

  handleCancelOrder(e, orderId) {
    e.preventDefault();
    this.props.onCancelOrder(orderId);
  }

  componentDidMount = async () => {
    let order = this.props.order;
    let products = [];
    this.setState({ loading: true });
    try {
      document.getElementById("loadMoreOngoingBookings").style.visibility =
        "hidden";
    } catch (err) {}

    for (let i = 0; i < order.products.length; i++) {
      let product = order.products[i];
      let { Status } = await getShipment(product, order);
      if (!["RETURNED", "RTO"].includes(Status)) {
        products.push(product);
      }
    }

    this.setState({ products: products, loading: false });
    try {
      document.getElementById("loadMoreOngoingBookings").style.visibility =
        "visible";
    } catch (err) {}
  };

  render() {
    let order = this.props.order;
    let display = "d-block";

    if (this.state.loading) {
      return <Spinner />;
    }

    return (
      <div className="container">
        {this.state.products.map((product) => (
          <OrderRow product={product} order={order} />
        ))}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    cancelOrderLoading: state.bookings.cancelOrderLoading,
    // userId: state.auth.userId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCancelOrder: (orderId) => dispatch(actions.onCancelOrder(orderId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OngoingOrders);
